import api from '../common/api/domainListApi';

const basePath = '/domainLists';

export default {
  getList(params = {}) {
    return api.get(basePath, { params });
  },
  create(domainList) {
    return api.post(`${basePath}`, domainList);
  },
  get(domainListId, params = {}) {
    return api.get(`${basePath}/${domainListId}`, { params });
  },
  update(domainListId, domainList) {
    return api.put(`${basePath}/${domainListId}`, domainList);
  },
  bulkUpload(domains) {
    return new Promise((resolve, reject) => {
      domains.forEach(async (domain) => {
        await api
          .post(`${basePath}`, domain)
          .then(() => {
            resolve('ok');
          })
          .catch(() => {
            reject('Error');
          });
      });
    });
  },
  getAll() {
    return api.get(`${basePath}/all/domains`, {});
  },
  updateBlackList(blackList) {
    return api.put(`${basePath}/blacklist/update`, blackList);
  },
  getBlackList() {
    return api.get(`${basePath}/blacklist/get`, {});
  }
};



// WEBPACK FOOTER //
// ./src/services/domainService.js